import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Korean RRN generator following Single Responsibility Principle
 */
export class KrGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true, birthDate = null } = options;

    let yymmdd;
    if (birthDate) {
      const date = new Date(birthDate);
      const year = date.getFullYear().toString().slice(-2);
      const month = this.padZero(date.getMonth() + 1, 2);
      const day = this.padZero(date.getDate(), 2);
      yymmdd = year + month + day;
    } else {
      const year = this.padZero(this.randomInt(0, 99), 2);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const day = this.padZero(this.randomInt(1, 28), 2);
      yymmdd = year + month + day;
    }

    // Generate 6 more digits
    const remaining = this.randomDigits(6);
    const partial = yymmdd + remaining;

    // Calculate check digit
    const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
    let sum = 0;

    for (let i = 0; i < 12; i++) {
      sum += parseInt(partial[i]) * weights[i];
    }

    const checkDigit = (11 - (sum % 11)) % 10;
    const rrn = partial + checkDigit;

    return formatted ? 
      `${rrn.substring(0, 6)}-${rrn.substring(6, 13)}` : 
      rrn;
  }
}